import { c as _c } from "react/compiler-runtime";
import { LocaleEnum } from '@systemeio/ui';
import useUser from 'shared/hooks/use-user';
import { HelpScout } from './help-scout';
import { BoldDesk } from './bolddesk';
import { ChatKit } from './chat-kit';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GrowthbookFlagsEnum } from 'growthbook/types';
import { isSIO } from 'shared/utils/is-sio';
const newBotLocales: LocaleEnum[] = [];
export function HelpBots() {
  const $ = _c(6);
  const {
    user,
    isCustomer
  } = useUser();
  const isAIOn = useFeatureIsOn(GrowthbookFlagsEnum["AI-assistant"]);
  if (!user) {
    return null;
  }
  const isDev = process.env.NEXT_PUBLIC_APP_ENV === "development";
  if (isDev) {
    return null;
  }
  const isSio = isSIO();
  if (!isSio) {
    return null;
  }
  let t0;
  if ($[0] !== user.dashboardLocale) {
    t0 = newBotLocales.includes(user.dashboardLocale);
    $[0] = user.dashboardLocale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const useNewBot = t0;
  const shouldShowChatKit = isAIOn && isCustomer;
  let t1;
  if ($[2] !== shouldShowChatKit || $[3] !== useNewBot || $[4] !== user.dashboardLocale) {
    t1 = <>{shouldShowChatKit ? <ChatKit /> : <><HelpScout shouldRender={!useNewBot} locale={user.dashboardLocale} /><BoldDesk shouldRender={useNewBot} locale={user.dashboardLocale} /></>}</>;
    $[2] = shouldShowChatKit;
    $[3] = useNewBot;
    $[4] = user.dashboardLocale;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}